var axios = require("axios");

var isSenior = function isSenior(date) {
  var nintyDays = new Date(new Date().getTime() + 90 * 24 * 60 * 60 * 1000);
  var isSixtyFive = nintyDays.setFullYear(nintyDays.getFullYear() - 65) >= new Date(date);

  if (!isSixtyFive) {
    return false;
  }

  return true;
};

var getAgeIn90 = function getAgeIn90(birthday) {
  var today = new Date();
  var birthDate = new Date(birthday);
  var nintyDays = new Date(today.getTime() + 90 * 24 * 60 * 60 * 1000);
  var ageIn90 = nintyDays.getFullYear() - birthDate.getFullYear();
  var month = nintyDays.getMonth() - birthDate.getMonth();

  if (month < 0 || month === 0 && nintyDays.getDate() < birthDate.getDate()) {
    ageIn90--;
  }

  return ageIn90;
};

var getAge = function getAge(birthday) {
  var today = new Date();
  var birthDate = new Date(birthday);
  var ageIn90 = getAgeIn90(birthday);
  var age = today.getFullYear() - birthDate.getFullYear();
  var month = today.getMonth() - birthDate.getMonth();

  if (month < 0 || month === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }

  if (ageIn90 > age) {
    age++;
  }

  return birthday === null ? null : age;
}; // Validation Logic


var validateCoverageID = function validateCoverageID(coverageID) {
  return coverageID && coverageID !== null;
};

var validateDate = function validateDate(date) {
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
    return false;
  }

  var parts = date.split("/");
  var day = parseInt(parts[1], 10);
  var month = parseInt(parts[0], 10);
  var year = parseInt(parts[2], 10);

  if (year < 1000 || year > 3000 || month == 0 || month > 12) {
    return false;
  }

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
    monthLength[1] = 29;
  }

  if (new Date(date) > new Date() || new Date(date) < new Date("1-1-1900")) {
    return false;
  }

  return day > 0 && day <= monthLength[month - 1];
};

var validateMaritalStatus = function validateMaritalStatus(maritalStatus) {
  return maritalStatus && maritalStatus !== null;
};

var validateState = function validateState(state) {
  return state && state !== null;
};

var fetchPrices = function fetchPrices(muleApiUrl, config, oldestDateOfBirth, coverageTier, state, maritalStatus) {
  return axios.get(muleApiUrl + "/pricing-api/v1/prices/medishare?tier=" + coverageTier + "&maritalStatus=" + maritalStatus + "&oldestDateOfBirth=" + oldestDateOfBirth + "&state=" + state, config).then(function (res) {
    return res.data;
  });
};

module.exports = {
  isSenior: isSenior,
  getAge: getAge,
  validateCoverageID: validateCoverageID,
  validateDate: validateDate,
  validateMaritalStatus: validateMaritalStatus,
  validateState: validateState,
  fetchPrices: fetchPrices
};